<template>
  <b-form-group v-slot="{ ariaDescribedby }">
    <b-form-radio-group
      v-model="model"
      v-if="model"
      :options="options"
      :aria-describedby="ariaDescribedby"
      button-variant="outline-primary"
      name="radio-btn-outline"
      buttons
    />
  </b-form-group>

</template>

<script>
import {BFormGroup, BFormRadioGroup, BModal} from "bootstrap-vue";

export default {
  components: {
    BModal,
    BFormGroup,
    BFormRadioGroup,
  },
  data() {
    return {
      options: [
        { text: "كافة التبرعات", value: "all" },
        { text: "التبرعات المالية", value: "bank_donations" },
        { text: "التبرعات العينية", value: "in_kind_donations " },
        { text: "المركبات", value: "machines" },
      ],
      model: "all",
    };
    
  },

  watch: {
    model(val) {
      this.$emit("filterChanged", val);
    },
  },
};
</script>
